module.exports = __webpack_public_path__ + "static/img/1.372e726.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/1.png
// module id = Z69R
// module chunks = 1